module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAxCAYAAABDEFA9AAABOElEQVRoQ+2Zyw3CMBBEx1QBNOAyENygDT5NEdqAWxBlpAA+VWAUBFIgTtY4WRTE5Oq1M3prz0i2WY6yqethA4MBpM/hbK6Yrw92J5VqjJvFODsFCX3+3eGc7O1QQ4y0pllMMicVvY8nqTWfzmmjnmLboOhbg2RJFgC3QWXQNAwVFbK1QdMgVHTECkETGyoUK0U4yVaZu0SGZLVC4e/IvgTLI0w6a12lYMkFSy3zHbJvHDCfLoqVuiV1Ju8myfr2NMl2ORS4Z7lnf866yheGl+4m2DibwWADoA/gCIdVZ8V+7a6rjVCgWC3rIlmSrbgD0LGu+hegS5Ja+RnLI1hLbNHQi7+9m3uyt9uY23EVsTFCQuZQbAilmBqSjaEWMufHyH76Kg5E+2QIvbqa/Am/yhN98xr5ZFOxNww4hoWxJFycAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/icon_6@2x.png
// module id = JWpb
// module chunks = 70